import { EditShareInfoComponent } from './edit-info.component';

export default EditShareInfoComponent;
